export default __webpack_public_path__ + "static/media/gallery_06.bc1aab17.jpg";